import type { PathButtonProps } from "shared/react";
import { splitEntity } from "shelving";
import { type CreatorEntity, getLeaderboardPath } from "shared/schema";
import { EntityBackgroundButton } from "../entity/EntityButton.js";
import { useQuery } from "../util/db.js";
import { RawLeaderboardSentence } from "./LeaderboardSentence.js";

/** Show a button containing the latest update from a leaderboard. */
export function LeaderboardButton({ cid, creator, ...props }: { cid: string; creator: CreatorEntity } & PathButtonProps): React.ReactElement | null {
	const [type] = splitEntity(creator);
	const store = useQuery("leaderboard", { cid, creator, $order: "!updated", $limit: 1 });
	return store.loading ? null : (
		<EntityBackgroundButton entity={creator} path={getLeaderboardPath(creator, cid)} {...props}>
			{store.count ? <RawLeaderboardSentence {...store.first} /> : <span>{`See ${type} leaderboard`}</span>}
		</EntityBackgroundButton>
	);
}
